import React from 'react';
import './float-config-container.scss';
type FloatConfigContainerType = {
  children: React.ReactNode;
};

const FloatConfigContainer = ({ children }: FloatConfigContainerType) => {
  return <div className="configurator-float">{children}</div>;
};

export default FloatConfigContainer;
